import { Navigate, Route, Routes } from "react-router-dom";
import { PublicLayout } from "./components/PublicLayout";
import { AdminLayout, ProtectedAdmin } from "./components/AdminLayout";
import { LandingPage } from "./pages/LandingPage";
import { CatalogPage } from "./pages/CatalogPage";
import { ProductPage } from "./pages/ProductPage";
import { CartPage } from "./pages/CartPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { PaymentPage } from "./pages/PaymentPage";
import { ConfirmationPage } from "./pages/ConfirmationPage";
import { TrackPage } from "./pages/TrackPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsOfUsePage } from "./pages/TermsOfUsePage";
import { AdminLoginPage } from "./pages/admin/AdminLoginPage";
import { AdminDashboardPage } from "./pages/admin/AdminDashboardPage";
import { AdminPaymentsPage } from "./pages/admin/AdminPaymentsPage";
import { AdminHelpMessagesPage } from "./pages/admin/AdminHelpMessagesPage";
import { AdminReviewsPage } from "./pages/admin/AdminReviewsPage";
import { AdminQueuePage } from "./pages/admin/AdminQueuePage";
import { AdminProductsPage } from "./pages/admin/AdminProductsPage";
import { AdminSettingsPage } from "./pages/admin/AdminSettingsPage";
import { AdminPaymentMethodsPage } from "./pages/admin/AdminPaymentMethodsPage";
import { AdminAccountPage } from "./pages/admin/AdminAccountPage";
import { AdminAnalyticsPage } from "./pages/admin/AdminAnalyticsPage";

export function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="shop" element={<CatalogPage />} />
        <Route path="products/:slug" element={<ProductPage />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="payment/:orderNumber" element={<PaymentPage />} />
        <Route path="order/:orderNumber/confirmed" element={<ConfirmationPage />} />
        <Route path="track" element={<TrackPage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="terms-of-use" element={<TermsOfUsePage />} />
      </Route>
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<ProtectedAdmin />}>
        <Route element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="analytics" element={<AdminAnalyticsPage />} />
          <Route path="payments" element={<AdminPaymentsPage />} />
          <Route path="help-messages" element={<AdminHelpMessagesPage />} />
          <Route path="reviews" element={<AdminReviewsPage />} />
          <Route path="queue" element={<AdminQueuePage />} />
          <Route path="products" element={<AdminProductsPage />} />
          <Route path="payment-methods" element={<AdminPaymentMethodsPage />} />
          <Route path="settings" element={<AdminSettingsPage />} />
          <Route path="account" element={<AdminAccountPage />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
